import React from 'react';
import { Menu, Dropdown, Icon, Divider, Badge, Modal, Select, Input, Row, Tag, Table, Form, message, Card, Col, Drawer, Skeleton, Button } from 'antd';
import { connect } from 'react-redux';
import SSAS from '../../scripts/ssas'
import request from '../../scripts/request'
import moment from 'moment'
import PhotoWindow from '../../pages/photo/sj_photo_img/sj_phto_img'//头像采集
import MbPage from '../public/mbPage'//密保设置
import HelpInfo from './header_helpInfo'
import '../../scripts/config'
import 'antd/dist/antd.css';
import '../../assets/css/style.css';

let $this;
let store;
//时钟
let today = new Date();
const { Meta } = Card;
let _sh = 0;
let dayNames = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
const { Option } = Select;
class HeaderRight extends React.Component {
    constructor(props) {
        super(props);
        $this = this;
        store = this.props.store;
        this.state = {
            rq: moment().format('YYYY年MM月DD日 HH:mm:ss'),
            qz: '上午好',
            color: '#fff',
            objUser: { ksdata: [] },
            coludLink: false,
            selectItem: {
                title: '', icon: '', key: '',
                modalParame: { title: '', icon: '', czfs: '', okText: '', width: '', maskClosable: false, footer: true, okButtonProps: { icon: '' }, cancelButtonProps: { icon: '', type: '' } },
                content: ''
            },
            selectMediaItem: {},
            tzxxData: [],
            mbData: [],
            DrawerVisible: false
        }
        setTimeout(() => {
            setInterval(() => {
                let y = moment().format('YYYY年MM月DD');
                let d = moment().format('HH:mm:ss');
                let hour = moment().format('H');
                let index = moment().format('d');
                let _qz = '上午好！';
                if (hour != _sh) {
                    if (hour < 6) { _qz = "凌晨好!" }
                    else if (hour < 9) { _qz = "早上好！" }
                    else if (hour < 12) { _qz = "上午好！" }
                    else if (hour < 14) { _qz = "中午好！" }
                    else if (hour < 17) { _qz = "下午好！" }
                    else if (hour < 19) { _qz = "傍晚好！" }
                    else if (hour < 22) { _qz = "晚上好！" }
                    else { _qz = "夜里好!" }
                }
                let _str = y + '(' + dayNames[index] + ') ' + d;
                this.setState({ rq: _str, qz: _qz });
            }, 1000);
        }, 500);
    }
    componentDidMount() {
        const _dqz = SSAS.pubXtszDqz(store, 'pub_coludlink');
        if (store.topContainer.pageName === 'index') {
            this.setState({ color: '#314659', coludLink: _dqz === 'True' ? true : false });
        }
        else {
            this.setState({ objUser: store.objUser, coludLink: _dqz === 'True' ? true : false });
        }
        setTimeout(() => {
            this.tzxxLoad();
        }, 1000);
    }
    //获取通知消息
    tzxxLoad = () => {
        request({
            url: 'api/Ycf/tzxxListLoad',
            method: 'post',
            data: {}
        }).then(function (res) {
            if (res !== null && res !== undefined) {
                $this.setState({ tzxxData: res.data || [] });
            }
        });
    }
    //退出
    powerOffClick = e => {
        Modal.confirm({
            content: '确定要退出当前系统吗?',
            icon: 'question-circle',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                $this.props.emitHandler('reLogin', null);
            }
        });
    }
    //返回主页
    homePageClick = e => {
        Modal.confirm({
            content: '确定要回首页吗?',
            icon: 'question-circle',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                $this.props.emitHandler('goHomePage', null);
            }
        });
    }
    menuClick = key => {
        switch (key) {
            case 'mmgx':
                this.passwordUpdate();
                break;
            case 'ggzd':
                this.updateClick('public');
                break;
            case 'ywzd':
                this.updateClick('pubprivatelic');
                break;
            case 'help':
                this.helpLoad();
                break;
            case 'grxx':
                this.userView();
                break;
            case 'mbsz':
                this.mbszWindow();
                break;
            case 'helpInfo':
                this.helpInfoWindow();
                break;
            default:
                message.info('功能暂时未开放');
                break;
        }
    }
    //字典更新
    updateClick = (value) => {
        let _pageName = store.topContainer.pageName;
        Modal.confirm({
            content: '确定更新字典信息吗?',
            icon: 'question-circle',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                if (value === 'public') {
                    $this.props.ParentTodo({ lx: 'DictionariesUpdate' });
                    setTimeout(() => {
                        $this.props.emitHandler('DictionariesUpdate', { pageName: 'homePage' });
                    }, 100);
                }
                else {
                    $this.props.ParentTodo({ lx: 'DictionariesUpdate' });
                    setTimeout(() => {
                        $this.props.emitHandler('DictionariesUpdate', { pageName: _pageName, mkid: store.topContainer.mkid });
                    }, 100);
                }
            }
        });
    }
    passwordUpdate = () => {
        let _omm = '';
        let _mm1 = '';
        let _mm2 = '';
        Modal.info({
            title: '密码更新',
            maskClosable: true,
            width: 450,
            okText: '更新',
            content: <Form {...{
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 5 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 12 },
                },
            }}>
                <Form.Item
                    label="原密码"
                    hasFeedback
                    validateStatus="error"
                >
                    <Input.Password placeholder="请输入原来的密码" style={{ width: 300 }} id="omm" onChange={e => { _omm = e.target.value }} />
                </Form.Item>
                <Form.Item
                    label="新密码"
                    hasFeedback
                    validateStatus="error"
                >
                    <Input.Password placeholder="请输入新密码" style={{ width: 300 }} id="mm1" onChange={e => { _mm1 = e.target.value }} />
                </Form.Item>
                <Form.Item
                    label="重新输入"
                    hasFeedback
                    validateStatus="error"
                >
                    <Input.Password placeholder="请重新输入密码" style={{ width: 300 }} id="mm2" onChange={e => { _mm2 = e.target.value }} />
                </Form.Item>
            </Form>,
            onOk: () => {
                const _dqz = SSAS.pubXtszDqz(store, 'pub_password');
                let contentPatternstr = '';

                if (_mm1 !== _mm2) {
                    contentPatternstr = '两次输入的密码不相同';
                }
                else if (_mm1 === ''||_mm1 === null||_mm1 === undefined||_mm2 === ''||_mm2 === null||_mm2 === undefined) {
                    contentPatternstr = '密码不能为空';
                }
                else if (_dqz === '1') {
                    const contentPattern = new RegExp(/(0|[1-9][0-9]*)/);
                    if (_mm1.length < 6 || _mm1.length > 20) {
                        contentPatternstr = '密码长度必须是6-20位';
                    }
                    else if (!contentPattern.test(_mm1)) {
                        contentPatternstr = '密码只能且必须数字';
                    }
                }
                else if (_dqz === '2') {
                    const contentPattern = new RegExp(/(0|[1-9][0-9]*)/);
                    const contentPattern1 = new RegExp(/[A-Z]+/);
                    const contentPattern2 = new RegExp(/[a-z]+/);
                    if (_mm1.length < 6 || _mm1.length > 20) {
                        contentPatternstr = '密码长度必须是6-20位';
                    }
                    else if (!contentPattern.test(_mm1)) {
                        contentPatternstr = '密码必须包含数字';
                    }
                    else if (!contentPattern1.test(_mm1)) {
                        contentPatternstr = '密码必须包含大写字母';
                    }
                    else if (!contentPattern2.test(_mm1)) {
                        contentPatternstr = '密码必须包含小写字母';
                    }
                }
                else {
                    const contentPattern = new RegExp(/(0|[1-9][0-9]*)/);
                    const contentPattern1 = new RegExp(/[A-Z]+/);
                    const contentPattern2 = new RegExp(/[a-z]+/);
                    const contentPattern3 = new RegExp(/[^%&',;=?$\x22]+/);

                    if (_mm1.length < 6 || _mm1.length > 20) {
                        contentPatternstr = '密码长度必须是6-20位';
                    }
                    else if (!contentPattern.test(_mm1)) {
                        contentPatternstr = '密码必须包含数字';
                    }
                    else if (!contentPattern1.test(_mm1)) {
                        contentPatternstr = '密码必须包含大写字母';
                    }
                    else if (!contentPattern2.test(_mm1)) {
                        contentPatternstr = '密码必须包含小写字母';
                    }
                    else if (!contentPattern3.test(_mm1)) {
                        contentPatternstr = '密码必须包含特殊字符';
                    }
                }
                if (contentPatternstr !== '') {
                    message.error(contentPatternstr);
                }
                else {
                    $this.passwordSave({ omm: _omm, mm1: _mm1, mm2: _mm2 });
                }
            }
        });
    }
    passwordSave = (values) => {
        request({
            url: 'api/Xtgl/czyjMmUpdate',
            method: 'post',
            data: values
        }).then(function (res) {
            if (res !== null && res !== undefined) {
                message.success('密码更新成功');
            }
        });
    }
    ///帮助中心
    helpLoad = () => {
        request({
            url: 'api/Xtgl/xtglHelp',
            method: 'post',
            data: {}
        }).then(function (res) {
            if (res !== null && res !== undefined) {
                $this.helpWindow(res.data);
            }
        });
    }
    //个人信息
    userView = () => {
        const { store } = this.props;
        const objUser = store.objUser;
        Modal.info({
            title: objUser.xm + '的个人信息',
            maskClosable: true,
            width: 400,
            okText: '关闭',
            content: <Card
                hoverable
                style={{ width: 340 }}
                cover={<img alt={objUser.xm} src={global.constants.address + objUser.imgurl} title='点击拍照' onClick={() => this.photoMe(objUser)} />}
            >
                <Meta title={objUser.xm} description={
                    <Row style={{ padding: '5px' }}>
                        <Col span={24}>科室:{objUser.ksmc}</Col>
                        <Col span={24}>工号:{objUser.dm}</Col>
                        <Col span={24}>电话:{objUser.lxdh}</Col>
                        <Col span={24}>单位:{objUser.dwmc}</Col>
                    </Row>
                } />
            </Card>
        });
    }
    //头像采集
    photoMe = (record) => {
        let _parame = {
            selectItem: {
                title: record.xm + '头像采集', icon: 'camera', key: 'photo',
                modalParame: { title: record.xm + '头像采集', icon: 'camera', czfs: 'add', okText: '完成', width: '490px', footer: true, maskClosable: true, okButtonProps: { icon: 'check' }, cancelButtonProps: { icon: 'close-circle', type: 'danger' } },
                content: <PhotoWindow store={store} onClose={$this.handleCancel} wrappedComponentRef={$this.saveFormRef}></PhotoWindow>
            },
            DrawerVisible: true
        };
        $this.setState(_parame);
    }
    //头像提交
    photoSave = () => {
        this.setState({ confirmLoading: true });
        const { form } = this.formRef.props;
        const { store } = this.props;
        const { objUser } = store;
        form.validateFields((err, values) => {
            if (err) {
                this.setState({ confirmLoading: false });
                return;
            }
            if (values.imgstr === '') {
                message.info('请点击右侧图像框拍照');
                this.setState({ confirmLoading: false });
            }
            else {
                const _photoparam = { dyb: 'dm_xtgl_dw_rydm', dybid: objUser.ryid, folderName: 'USER', img: values.imgstr };
                request({
                    url: 'api/Photo/photoSave',
                    method: 'post',
                    data: _photoparam
                }).then(function (res) {
                    $this.setState({ confirmLoading: false });
                    if (res !== null && res !== undefined) {
                        $this.setState({ DrawerVisible: false });
                        message.success('头像保存成功,重新登录生效');
                    }
                });
            }
        });
    }
    saveFormRef = formRef => {
        this.formRef = formRef;
    };
    helpWindow = (data) => {
        const columns = [
            {
                title: '序号',
                dataIndex: 'no',
                width: 50,
                textAlign: 'center',
                key: 'no',
            },
            {
                title: '名称',
                dataIndex: 'mc',
                width: 260,
                key: 'mc',
            },
            {
                title: '说明',
                dataIndex: 'bz',
                key: 'bz',
            },
            {
                title: '下载',
                key: 'url',
                textAlign: 'center',
                width: 50,
                dataIndex: 'url',
                render: (value, record) => {
                    return <a href={global.constants.address + value}><Tag color='#f50'>下载</Tag ></a>
                }
            }
        ];
        Modal.info({
            title: '帮助中心',
            maskClosable: true,
            width: 840,
            okText: '关闭',
            content: <Table
                columns={columns}
                size='small'
                bordered
                pagination={false}
                dataSource={data}
                footer={() => <Row>
                    <Col span={12}>socketAddress(通信地址)：{global.constants.socketaddress}</Col>
                    <Col span={12}>apiAddress(接口地址)：{global.constants.address}</Col>
                </Row>
                }
            />
        });
    }
    ksOnChange = (value, option) => {
        const user = this.state.objUser;
        this.setState({ objUser: Object.assign({}, user, { czy_ksid: value, ksid: value, ksmc: option.props.children }) });
        this.props.ksOnChange(value, option.props.children)
    }
    //通知信息查阅标记
    tzxxView = (record) => {
        Modal.info({
            title: record.xxtitle,
            content: (
                <div>
                    {record.xxlr}
                </div>
            ),
            maskClosable: true,
            okText: '已查看',
            onOk() {
                request({
                    url: 'api/Ycf/tzxxStatusCallBack',
                    method: 'post',
                    data: { tzid: record.tzid }
                }).then(function (res) {
                    if (res !== null && res !== undefined) {
                        $this.tzxxLoad();//通知信息
                    }
                });
            },
        });
    }
    //密保设置
    mbszWindow = () => {
        const { store } = this.props;
        const _mbsz = SSAS.pubXtszDqz(store, 'pub_kqmb');
        if (_mbsz === 'True') {
            Modal.info({
                icon: 'safety-certificate',
                title: '密保安全',
                mask: true,
                width: 480,
                content: <MbPage store={store} mbSubmitChange={$this.mbSubmitChange}></MbPage>,
                onOk: () => {
                    $this.mbSave();
                }
            })
        }
        else {
            message.info('当前机构未启用密保安全功能');
        }
    }
    mbSave = () => {
        const { mbData } = this.state;
        if (mbData.length > 2) {
            request({
                url: 'api/Xtgl/czyMbSet',
                method: 'post',
                data: { list: JSON.stringify(this.state.mbData) }
            }, { loading: true, msg: '密保提交中...' }).then(function (res) {
                if (res !== null && res !== undefined) {
                    message.success('密保设置成功');
                }
            });
        }
        else {
            message.error('数据填写不规范');
        }
    }
    mbSubmitChange = (data) => {
        this.setState({ mbData: data });
    }
    //帮助视频
    helpInfoWindow = () => {
        Modal.info({
            title: "帮助视频",
            width: '95%',
            content: (
                <HelpInfo></HelpInfo>
            ),
            maskClosable: false,
            okText: '关闭',
            onOk() {

            },
        });
    }
    onError = () => {

    }
    render() {
        const { store } = this.props;
        const _menuHelp = (
            <Menu onClick={e => this.menuClick(e.key)}>
                <Menu.Item key='grxx'>
                    <a href="javascript:void(0);" title="查看个人信息"><Icon type="read"></Icon>&nbsp;个人信息</a>
                </Menu.Item>
                <Menu.Item key='mmgx'>
                    <a href="javascript:void(0);" title="修改密码"><Icon type="edit" onClick={() => this.passwordUpdate()}></Icon>&nbsp;修改密码</a>
                </Menu.Item>
                <Menu.Item key='mbsz'>
                    <a href="javascript:void(0);" title="设置密保问题"><Icon type="safety-certificate"></Icon>&nbsp;密保设置</a>
                </Menu.Item>
                <Menu.Item key='ggzd'>
                    <a href="javascript:void(0);" title="更新本地公用字典信息" ><Icon type="hdd" ></Icon>&nbsp;公用字典更新</a>
                </Menu.Item>
                {
                    store.topContainer.pageName === 'index' ?
                        <Menu.Item key='ywzd'>
                            <a href="javascript:void(0);" title="更新当前业务字典信息" ><Icon type="setting" ></Icon>&nbsp;业务字典更新</a>
                        </Menu.Item>
                        : ''
                }
                <Menu.Item key='help'>
                    <a href="javascript:void(0);" title="帮助中心"><Icon type="question-circle" ></Icon>&nbsp;帮助中心</a>
                </Menu.Item>
                <Menu.Item key='helpInfo'>
                    <a href="javascript:void(0);" title="操作视频"><Icon type="play-square" ></Icon>&nbsp;操作视频</a>
                </Menu.Item>
            </Menu>
        );
        const _msgMenu = (
            <Menu>
                {
                    this.state.tzxxData.map(item => {
                        return <Menu.Item onClick={e => this.tzxxView(item)}>
                            <span>{item.xh}、{SSAS.pubDefaultValue(item.fsrq, 'date')}<Divider type='vertical'></Divider>{item.xxtitle}</span>
                        </Menu.Item>
                    })
                }
            </Menu>
        );
        const _wsuser = {
            czyid: store.objUser.czyid,
            yhid: store.objUser.yhid,
            xm: store.objUser.xm,
            dwid: store.objUser.dwid
        }
        return (
            <div style={{ width: '100%', textAlign: 'right', paddingRight: '20px' }}>
                {this.state.coludLink ?
                    <a style={{ color: this.state.color }} href={'SehrWS://' + JSON.stringify(_wsuser)} title='点击启动云链服务'><Icon type="link"></Icon></a>
                    :
                    <a style={{ color: '#ccc' }} href='javascript:void(0);' title='云链服务已关闭,开启请联系管理员'><Icon type="link"></Icon></a>
                }
                <Divider type="vertical" />
                <Dropdown overlay={_menuHelp}>
                    <a href="javascript:void(0);" style={{ color: this.state.color }}><Icon type="user" />&nbsp;{this.state.qz}{this.props.store.objUser.xm}</a>
                </Dropdown>

                {
                    store.topContainer.pageName === 'homePage' ?
                        <Divider type="vertical" />
                        : ''
                }
                {
                    store.topContainer.pageName === 'homePage' ?
                        <Select
                            showSearch
                            style={{ width: 150 }}
                            placeholder="请选择科室"
                            size='small'
                            value={this.state.objUser.czy_ksid}
                            optionFilterProp="children"
                            onChange={(value, option) => this.ksOnChange(value, option)}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {this.state.objUser.ksdata.map(item => (
                                <Option value={item.value}>{item.label}</Option>
                            )
                            )}
                        </Select>
                        : ''
                }
                <Divider type="vertical" />
                <span style={{ color: this.state.color }}>{this.state.rq}</span>
                <Divider type="vertical" />
                <Dropdown overlay={_msgMenu}><a href="javascript:void(0);" title="提醒消息" style={{ color: this.state.color }}><Icon type="bell" />&nbsp;<Badge count={this.state.tzxxData.length}><span>消息</span></Badge></a></Dropdown>
                <Divider type="vertical" />
                {
                    store.topContainer.pageName === 'index' ?
                        <a href="javascript:void(0);" style={{ color: this.state.color }} title="点击返回主页" onClick={this.homePageClick.bind(this)}><Icon type="home" />&nbsp;首页</a>
                        : null
                }
                {
                    store.topContainer.pageName === 'index' ?
                        <Divider type="vertical" />
                        : null
                }
                <a href="javascript:void(0);" style={{ color: this.state.color }} title="点击注销登录" onClick={this.powerOffClick.bind(this)}><Icon type="poweroff" />&nbsp;注销</a>

                <Drawer
                    title={<span><Icon type={this.state.selectItem.modalParame.icon}></Icon><Divider type="vertical" />{this.state.selectItem.modalParame.title}</span>}
                    placement="right"
                    width={this.state.selectItem.modalParame.width}
                    closable={true}
                    destroyOnClose={true}
                    maskClosable={this.state.selectItem.modalParame.maskClosable}
                    onClose={() => { this.handleViewCancel() }}
                    visible={this.state.DrawerVisible}
                >
                    <Skeleton active loading={!this.state.DrawerVisible}>
                        <div style={{ marginBottom: '40px' }}>{this.state.selectItem.content}</div>
                    </Skeleton>
                    {this.state.selectItem.modalParame.footer ?
                        <div style={{ width: '100%', bottom: '0px', padding: '5px', position: 'absolute', backgroundColor: '#ffffff' }}>
                            <Divider type="horizontal"></Divider>
                            <Row gutter={1}>
                                <Col span={24} style={{ textAlign: 'right', paddingRight: '40px' }}>
                                    <Button type={this.state.selectItem.modalParame.cancelButtonProps.type} icon={this.state.selectItem.modalParame.cancelButtonProps.icon} onClick={() => this.handleViewCancel()}>取消</Button>
                                    <Divider type="vertical"></Divider>
                                    <Button type='primary' loading={this.state.confirmLoading} icon={this.state.selectItem.modalParame.okButtonProps.icon} onClick={() => this.photoSave()}>{this.state.selectItem.modalParame.okText || '提交'}</Button>
                                </Col>
                            </Row>
                        </div>
                        : null}
                </Drawer>

            </div >
        );
    }
}
//需要渲染什么数据
function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        headerDispatch: (par) => dispatch(
            {
                type: par.type, data: par.data
            }
        )
    }
}
//连接组件
HeaderRight = connect(mapStateToProps, mapDispatchToProps)(HeaderRight)
export default HeaderRight;